import type {ConferenceApiModel} from '../../../api/conference';
import type {Nullable} from '../../utility-types';

export const isChatConference = (conference?: Nullable<ConferenceApiModel>) =>
  conference?.type === 'chat';
